export const strapiSections = {
  sectionCardTypeOne: 'section_card_type_one',
  sectionCardTypeTwo: 'section_card_type_two',
  sectionCardTypeThree: 'section_card_type_three',
  sectionCardTypeFour: 'section_card_type_four',

  bottomSheet: 'bottom_sheet',

  listingV0: 'listing_v0',
}
export const eventData = {
  strapiWidgetCtaClick: 'strapi_widget_cta_click',
  bottomStickyCtaClick: 'bottom_sticky_cta_click',

  // Listing Widget
  listingChicletClick: 'listing_chiclet_click',
  listingLinkCtaClick: 'listing_link_cta_click',
  listingViewAllButtonClick: 'listing_view_all_button_click',
  listingItemClick: 'listing_item_click',

  // AMC Widget
  AMCWidgetClick: 'amc_widget_click',
  AMCWidgetCTAClick: 'amc_widget_cta_click',
}

export const eventMapping = {
  [eventData.strapiWidgetCtaClick]: {
    event: eventData.strapiWidgetCtaClick,
  },
  [eventData.bottomStickyCtaClick]: {
    event: eventData.bottomStickyCtaClick,
  },

  // Listing Widget
  [eventData.listingChicletClick]: {
    event: eventData.listingChicletClick,
  },
  [eventData.listingLinkCtaClick]: {
    event: eventData.listingLinkCtaClick,
  },
  [eventData.listingViewAllButtonClick]: {
    event: eventData.listingViewAllButtonClick,
  },
  [eventData.listingItemClick]: {
    event: eventData.listingItemClick,
  },

  // AMC Widget
  [eventData.AMCWidgetClick]: {
    event: eventData.AMCWidgetClick,
  },
  [eventData.AMCWidgetCTAClick]: {
    event: eventData.AMCWidgetCTAClick,
  },
}
